"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Section = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
require("./Section.scss");
var Section = function Section(_ref) {
  var className = _ref.className,
    content = _ref.content,
    label = _ref.label;
  var Icon = Section.Icon;
  var rootClassName = (0, _classnames["default"])('cds-FooterSection', className);
  var labelId = 'FooterSection-' + "".concat(label || 'Section').replace(/[^a-zA-Z0-9]/g, '');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName,
    key: label
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "checkbox",
    id: labelId
  }), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: labelId
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "cds-FooterSection-Title"
  }, /*#__PURE__*/_react["default"].createElement(Icon, {
    name: _Icon.ICON_NAME.arrowRight
  }), label)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-FooterSection-Content"
  }, content));
};
exports.Section = Section;
Section.Icon = _Icon.Icon;